module.exports = __webpack_public_path__ + "img/Slider.ec449945.jpg";